import { render, staticRenderFns } from "./OTDetailView.vue?vue&type=template&id=09ee784b&scoped=true&lang=pug"
import script from "./OTDetailView.vue?vue&type=script&lang=js"
export * from "./OTDetailView.vue?vue&type=script&lang=js"
import style0 from "./OTDetailView.vue?vue&type=style&index=0&id=09ee784b&prod&scoped=true&lang=css"
import style1 from "./OTDetailView.vue?vue&type=style&index=1&id=09ee784b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee784b",
  null
  
)

export default component.exports